import MenuIcon from '@mui/icons-material/Menu'
import {
  AppBar,
  Avatar,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Theme,
  Toolbar,
  Typography,
  useMediaQuery,
} from '@mui/material'
import React from 'react'
import { useLocation } from 'react-router'
import items from './navigationItems'

type HeaderProps = {
  name: string
  onDrawerToggle: () => void
  onLogOut: () => void
}

const Header = (props: HeaderProps) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const { name, onDrawerToggle, onLogOut } = props
  const location = useLocation()

  const smUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'))

  let title = ''

  for (const { children } of items) {
    for (const { id, path } of children) {
      if (!location.pathname.includes(path)) continue
      title = id
      break
    }
  }

  return (
    <AppBar color="primary" position="sticky" elevation={0}>
      <Toolbar>
        <Grid container size="grow" spacing={1} sx={{ alignItems: 'center' }}>
          {!smUp && (
            <Grid size="grow">
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={onDrawerToggle}
                sx={{ ml: -1 }}
                size="large">
                <MenuIcon />
              </IconButton>
            </Grid>
          )}
          <Grid>
            <Typography component="h1" variant="h4">
              {title}
            </Typography>
          </Grid>

          <Grid size="grow" container sx={{ justifyContent: 'flex-end' }}>
            <IconButton color="inherit" onClick={(e) => setAnchorEl(e.currentTarget)} sx={{ padding: 4 }} size="large">
              <Avatar>{name[0]}</Avatar>
            </IconButton>
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={() => setAnchorEl(null)}>
              <MenuItem onClick={() => onLogOut()}>Logout</MenuItem>
            </Menu>
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  )
}

export default Header
